<template>
  <div class="row-actions" @click.stop>
    <button
      v-if="showView"
      type="button"
      class="row-action"
      :title="viewTitle"
      @click="$emit('view')"
    >
      <feather-icon icon="EyeIcon" :size="String(size)" />
    </button>
    <button
      v-if="showEdit"
      type="button"
      class="row-action"
      :title="editTitle"
      :disabled="editDisabled"
      @click="$emit('edit')"
    >
      <feather-icon icon="EditIcon" :size="String(size)" />
    </button>
    <slot name="extra" />
    <button
      v-if="showDelete"
      type="button"
      class="row-action row-action--danger"
      :title="deleteTitle"
      :disabled="deleteDisabled"
      @click="$emit('delete')"
    >
      <feather-icon icon="Trash2Icon" :size="String(size)" />
    </button>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RowActions',
  props: {
    showView: { type: Boolean, default: false },
    showEdit: { type: Boolean, default: true },
    showDelete: { type: Boolean, default: true },
    editDisabled: { type: Boolean, default: false },
    deleteDisabled: { type: Boolean, default: false },
    viewTitle: { type: String, default: 'View' },
    editTitle: { type: String, default: 'Edit' },
    deleteTitle: { type: String, default: 'Delete' },
    size: { type: [String, Number], default: 16 },
  },
}
</script>

<style lang="scss">
.row-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
}

.row-actions .dropdown,
.row-actions .btn-group {
  display: inline-flex;
}

.row-actions .dropdown .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #6e6b7b;
}

.row-actions .row-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #6e6b7b;
  cursor: pointer;
  line-height: 1;

  &:hover:not(:disabled) {
    background: #f3f2f7;
    color: #5e5873;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.2);
  }
}

.row-actions .row-action--danger:hover:not(:disabled) {
  background: rgba(234, 84, 85, 0.12);
  color: #ea5455;
}

.row-actions .row-action--success:hover:not(:disabled) {
  background: rgba(40, 199, 111, 0.12);
  color: #28c76f;
}

.row-actions .row-action--warning:hover:not(:disabled) {
  background: rgba(255, 159, 67, 0.16);
  color: #ff9f43;
}
</style>
